import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";

interface ReasoningBubbleProps {
  content: string;
  streaming: boolean;
  durationMs?: number;
}

function formatDuration(ms: number | undefined): string {
  if (!ms) return "";
  const s = Math.round(ms / 1000);
  return `${s}s`;
}

export function ReasoningBubble({ content, streaming, durationMs }: ReasoningBubbleProps) {
  const [expanded, setExpanded] = useState(false);

  if (streaming) {
    return (
      <div className="flex items-center gap-2 text-xs text-muted-foreground italic ms-2 my-2">
        <span data-testid="reasoning-pulse" className="inline-block h-2 w-2 rounded-full bg-muted-foreground animate-pulse" />
        <span>Thinking…</span>
      </div>
    );
  }

  return (
    <div className="ms-2 my-2">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="flex items-center gap-1 text-xs text-muted-foreground italic hover:text-foreground"
        aria-expanded={expanded}
      >
        {expanded ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <span>Thought for {formatDuration(durationMs)}</span>
      </button>
      {expanded && (
        <div className="mt-1 ps-4 text-xs text-muted-foreground italic whitespace-pre-wrap border-s border-border">
          {/* M12: model-generated reasoning tokens are untrusted text —
              isolate via <bdi> so any latent bidi-override characters
              cannot reorder the surrounding chat UI in RTL context. */}
          <bdi>{content}</bdi>
        </div>
      )}
    </div>
  );
}
